import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { get } from 'lodash/fp';
import { ItemType } from '../../../../../constants/inventory/InventoryTypes';

const { Cell } = Table;

const GenderCell = ({ dataKey, rowData, ...props }) => (
  <Cell {...props}>
    {get(dataKey, rowData) === ItemType ? 'Item' : 'Package'}
  </Cell>
);

GenderCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

GenderCell.defaultProps = {
  rowData: null
};

export default GenderCell;
